const PREFIX = 'LISTVIEW';

export const LISTVIEW_SESSION_STORAGE_KEYS = {
  FILTERED_CLIENTS: `${PREFIX}_FILTERED_CLIENTS`
};
